import React, {ReactNode} from 'react'
import {Layout, Row, Col} from 'antd'
import styles from './AnalyticsLayout.module.scss'

export interface AnalyticsLayoutProps {
  globalContent?: ReactNode
  navigationContent?: ReactNode
  children: ReactNode
}

const AnalyticsLayout: React.FC<AnalyticsLayoutProps> = ({
                                                           globalContent,
                                                           navigationContent,
                                                           children,
                                                         }) => {
  return (
    <Layout className={`${styles.analyticsLayout}`}>
      <div className={styles.analyticsWrapper}>
        <div className={styles.topSection}>
          <div className={styles.globalSectionContent}>
            {globalContent}
          </div>
        </div>

        <div className={styles.bottomSection}>
          <div className={styles.navigationSectionContent}>
            {navigationContent}
          </div>
        </div>
      </div>

      <div style={{
        zIndex: 1,
        width: '100%',
      }}>
        {children}
      </div>

    </Layout>
  )
}

export default AnalyticsLayout
